"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _HeaderCell = _interopRequireDefault(require("./HeaderCell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Head(_ref) {
  var columns = _ref.columns,
      restHeadProps = _objectWithoutProperties(_ref, ["columns"]);

  return _react.default.createElement("thead", null, _react.default.createElement("tr", null, columns.map(function (_ref2, colIndex) {
    var DataCell = _ref2.DataCell,
        name = _ref2.name,
        getCellKey = _ref2.getCellKey,
        CustomHeaderCell = _ref2.HeaderCell,
        getCellAttrs = _ref2.getCellAttrs,
        rest = _objectWithoutProperties(_ref2, ["DataCell", "name", "getCellKey", "HeaderCell", "getCellAttrs"]);

    return _react.default.createElement(_HeaderCell.default, _extends({
      colIndex: colIndex,
      key: name,
      name: name,
      CustomHeaderCell: CustomHeaderCell
    }, rest, restHeadProps));
  })));
}

var typedMemo = _react.default.memo;

var _default = typedMemo(Head);

exports.default = _default;